import cleanDeep from 'clean-deep';

import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';

import { PostErrorResponse } from './types';

export type PostGenericEndpointParams<RequestData> = {
    data: RequestData;
    lang?: string;
    token?: string | null;
};

export type PostGenericEndpointResponse<RequestData> = PostGenericEndpointParams<RequestData> & {
    path?: string;
    isApiPath?: boolean;
};

const getQueryParams = (lang: string = 'en') => {
    if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        url.searchParams.set('culture', lang);

        return url.searchParams.toString();
    }

    return `culture=${lang}`;
};

export const postGenericEndpoint = async <Request, Response>(params: PostGenericEndpointResponse<Request>): Promise<Response> => {
    const { data, path, lang, token, isApiPath = true } = params;

    const baseUrl = isApiPath ? `${PUBLIC_IDM_API_URL_ENV}/api` : PUBLIC_IDM_API_URL_ENV;

    const payload = cleanDeep(data);

    const queryParams = getQueryParams(lang);

    const headers = {
        'Content-Type': 'application/json',
        ...(token && { "X-XSRF-TOKEN": token }),
    };

    return fetch(`${baseUrl}/${path}?${queryParams}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
        credentials: 'include',
    }).then((response) => {
        if (response.ok) return response.json().then(data => data as Response);

        return response.json().then(error => {
            throw error as PostErrorResponse
        });
    }).catch((error: PostErrorResponse) => {
        throw error as PostErrorResponse;
    });
};
